export default (value) => {

  return value.replace(/[^\d]/g, '').substr(0, 10);

}



// WEBPACK FOOTER //
// ./src/components/normalize/NumberNormalize.js